var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile"},[_c('router-view'),_c('FooterDom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }